<template>
  <div>
    <div class="border rounded-full flex px-2 py-1">
      <div class="flex items-center mx-2 font-mono">
        <div
          style="color: transparent; height: 6px; width: 18px;"
          class="border-red-600 border-4 rounded mr-2"
        ></div>
        <div>
          0-49
        </div>
      </div>
      <div class="flex items-center mx-2 font-mono">
        <div
          style="color: transparent; height: 6px; width: 18px;"
          class="border-orange-600 border-4 rounded mr-2"
        ></div>
        <div>
          50-89
        </div>
      </div>
      <div class="flex items-center mx-2 font-mono">
        <div
          style="color: transparent; height: 6px; width: 18px;"
          class="border-green-600 border-4 rounded mr-2"
        ></div>
        <div>
          90-100
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PagespeedColorScoreComponent",
};
</script>

<style></style>
